import propTypes from 'prop-types';
import React from 'react';
import { SearchEntries, SearchResults } from 'rp-bloodstock-search';
import SearchSwitch from './Switch';

export default function Search({ params: { tab = SearchSwitch.TAB_ENTRIES } }) {
    return (
        <div>
            <SearchSwitch tab={tab} />
            {(() => {
                switch (tab) {
                    case SearchSwitch.TAB_ENTRIES:
                        return <SearchEntries />;
                    case SearchSwitch.TAB_RESULTS:
                        return <SearchResults />;
                    default:
                        return null;
                }
            })()}
        </div>
    );
}

Search.propTypes = {
    params: propTypes.shape({
        tab: propTypes.oneOf([
            SearchSwitch.TAB_ENTRIES,
            SearchSwitch.TAB_RESULTS,
        ]),
    }).isRequired,
};



// WEBPACK FOOTER //
// ./src/js/Search/Search.jsx